// src/pages/HandleExternalRedirect.jsx

import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import api from 'api/client';

const HandleExternalRedirect = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const encodedPayload = queryParams.get('payload');

    let finalRedirect = '/dashboard';

    if (encodedPayload) {
      try {
        const payload = JSON.parse(decodeURIComponent(encodedPayload));
        if (payload.token) {
          localStorage.setItem('token', payload.token);
          api.setToken(payload.token);
        }
        if (payload.product) {
          localStorage.setItem('Product', payload.product);
          finalRedirect = '/dashboard';
        }
      } catch (err) {
        console.error('Failed to parse payload', err);
      }
    }

    history.replace(finalRedirect);
  }, [location.search, history]);

  return null; // no visual flicker
};

export default HandleExternalRedirect;
